import { parseSensorPositionFormula } from './labelUtils';
import { detectCategory } from './iaCategories';
import { getLabelColor } from './labelColorStore';

export const mapApiLabel = (l) => {
  const labelType = l.source === 'IA' ? 'IA' : 'JALON';
  const labelText = l.label_text ?? l.label;
  const category = labelType === 'IA' ? detectCategory(labelText) : null;
  return {
    id: l.id,
    pk: l.pk_test_ref ?? null,
    t: l.time_unix ?? l.t,
    label: labelText,
    note: l.note || '',
    labelType,
    iconType: category ?? (labelType === 'IA' ? 'circle' : 'diamond'),
    category,
    // Couleur personnalisée (Jalons) — partagée par nom, persistée localement.
    color: l.color_hex ?? l.color ?? getLabelColor(labelText),
    precision: l.score ? parseFloat(l.score) : null,
    urlSon: l.audio_path ?? l.path ?? null,
    idSensor: l.id_sensor ?? null,
    positionInSensor: l.position_in_sensor ?? null,
  };
};

export const mapApiSection = (s) => ({
  id: s.id,
  idSensor: s.id_sensor,
  pkStart: s.pk_test_ref_start,
  pkEnd: s.pk_test_ref_end,
  tStart: s.time_start ?? s.t_start,
  tEnd: s.time_end ?? s.t_end,
  label: s.phase_text ?? s.label,
  color: s.color_hex ?? s.color,
});

export const mapDraftToApiPayload = (draft) => {
  const { sensorId, position } = parseSensorPositionFormula(draft.sensorAndPosition);
  return {
    id_sensor: sensorId,
    position_in_sensor: position,
    pk_test_ref: draft.pk ?? null,
    time_unix: draft.t,
    label_text: draft.label ?? '',
  };
};
